/**
 * Animation constants for consistent animations across the application
 */

// Tower animation configurations
export const TOWER_ANIMATIONS = {
  // Standard tower drop animation
  DROP: {
    dropDuration: 0.6, // Duration of the drop animation
    dropDelay: 0.08, // Delay between each cube's drop animation
    dropHeight: 800, // Starting height for the drop animation (px)
    springStiffness: 300, // Spring stiffness for the drop animation
    springDamping: 25, // Spring damping for the drop animation
    springMass: 1.2, // Spring mass for the drop animation
  },

  // Mobile-optimized tower animation
  MOBILE: {
    fadeDuration: 0.4, // Duration of the fade animation
    fadeDelay: 0.05, // Delay between each cube's fade animation
    scaleFrom: 0.9, // Starting scale for the animation
  },

  // Easter egg animation
  EASTER_EGG: {
    duration: 0.8,
    staggerDelay: 0.05,
    rotationDegrees: 360,
    scaleUp: 1.1,
    scaleDown: 0.9,
  },
}

// Menu animation configurations
export const MENU_ANIMATIONS = {
  // Header menu animation
  HEADER: {
    openDuration: 0.4,
    closeDuration: 0.3,
    staggerDelay: 0.05,
    itemEntrance: {
      y: -12,
      opacity: 0,
    },
    itemExit: {
      y: -8,
      opacity: 0,
    },
  },

  // Mobile menu animation
  MOBILE: {
    openDuration: 0.5,
    closeDuration: 0.2,
    staggerDelay: 0.03,
  },
}

// Page transition animations
export const PAGE_TRANSITIONS = {
  // Standard page transition
  STANDARD: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.3 },
  },
  SLIDE_UP: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.4 },
  },
}

// Floating element animations
export const FLOATING_ANIMATIONS = {
  // Subtle floating animation
  SUBTLE: {
    y: [0, -8, 0],
    transition: {
      duration: 3,
      repeat: Number.POSITIVE_INFINITY,
      repeatType: "mirror",
      ease: "easeInOut",
    },
  },

  // Medium floating animation
  MEDIUM: {
    y: [0, -12, 0],
    transition: {
      duration: 2.5,
      repeat: Number.POSITIVE_INFINITY,
      repeatType: "mirror",
      ease: "easeInOut",
    },
  },

  // Strong floating animation
  STRONG: {
    y: [0, -16, 0],
    transition: {
      duration: 2,
      repeat: Number.POSITIVE_INFINITY,
      repeatType: "mirror",
      ease: "easeInOut",
    },
  },
}
